export default __webpack_public_path__ + "static/media/7@3x.c0981666.png";